<template>
	<div class="popup__wrap">
		<transition name="fade-popup" appear>
			<div class="popup">
				<span class="popup__title section-title">
					{{ data.popupTitle }}
				</span>
				<span class="popup__title popup__title--name section-title">
					{{ data.propertyName }}
				</span>
				<span class="popup__title popup__title--date section-subtitle" v-if="data.propertyCreated">
					Date Listed: {{ changeDateFormat(data.propertyCreated) }}
				</span>

				<div class="table-wrap" :class="{'table-empty': noHistory || preloader}">
					<BlockTable
						class="popup__table"
						:data="data.DataMatchCustomer"
						v-if="data.DataMatchCustomer.items.length"
						@deleteHistoryRow="deleteHistoryRow"
					/>

					<span class="popup__empty" v-if="noHistory">There's no history for this property at the moment.</span>

					<PartLoaderBig v-if="preloader"/>
				</div>

				<div class="popup-form__wrap-close-popup">
					<a href="javascript:" @click="closePopup">
						<SvgIcon class="close-icon" iconName="ico-close-sm"/>
					</a>
				</div>
			</div>
		</transition>
		<PartPopupDelete
			v-if="showPopupDelete"
			:data="PopupDelete"
			@confirmPopupDelete="confirmPopupDelete"
			@closePopupDelete="closePopupDelete"
		>
			<template v-slot:popupTitle>Are you sure you want to delete this row from history?</template>
			<template v-slot:popupCancel>No</template>
			<template v-slot:popupConfirm>Yes</template>
		</PartPopupDelete>
	</div>
</template>

<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import PartPopupDelete from '@/components/parts/PartPopupDelete';
import BlockTable from '@/components/blocks/BlockTable';
import { formatDate } from '@/config/util';
import PartLoaderBig from '@/components/parts/PartLoaderBig';

export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			preloader: true,
			noHistory: false,
			showPopupDelete: false,
			PopupDelete: {
				itemID: ''
			},
			rowForDelete: null
		};
	},
	components: {
		BlockTable,
		SvgIcon,
		PartLoaderBig,
		PartPopupDelete
	},
	watch: {
		data: {
			handler(val) {
				if (val) {
					if (!this.data.DataMatchCustomer.items.length) {
						this.noHistory = true;
					}
					this.preloader = false;
				}
			},
			deep: true
		}
	},
	methods: {
		closePopup() {
			this.noHistory = false;
			this.$emit('closePopupPropertyHistory');
		},
		changeDateFormat(date) {
			return formatDate(date);
		},
		deleteHistoryRow(item) {
			this.showPopupDelete = true;
			this.PopupDelete.itemID = item.id;
			this.rowForDelete = {
				history_id: item.id,
				property_id: item.property_id
			};
		},
		closePopupDelete() {
			this.showPopupDelete = false;
		},
		confirmPopupDelete() {
			this.showPopupDelete = false;
			this.$store.dispatch('deleteHistoryRow', this.rowForDelete).then(() => {
				this.$emit('updateHistoryTable', this.rowForDelete.property_id);
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.table-wrap {
	padding-bottom: 50px;
	height: 100%;

	@include mq(1024px) {
		padding-bottom: 30px;
	}
}

.popup__title {
	padding-bottom: 20px;
}

.close-icon {
    position: absolute;
    right: 15px;
    top: 15px;
	color: $fiord;
	font-size: 20px;
	transition: $dur $ease;
	cursor: pointer;

	@include hover {
		color: $dodger-blue;
	}
}

.popup__empty {
	font-family: $font-main;
	font-weight: 500;
	font-size: 18px;
	color: $silver-chalice;
	text-align: center;

	@include mq($sm) {
		font-size: 16px;
	}
}

.popup__wrap {
    position: fixed;
    top: 50%;
    transform: translate(-50%, -50%);
    left: 50%;
    width: 100%;
    height: 100vh;
    z-index: 999999;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba($slate-gray, .5);
}

.popup {
    max-width: 1216px;
    width: 100%;
    background-color: $white;
    display: flex;
    flex-direction: column;
    justify-content: center;
	box-shadow: 0 2px 4px rgba($black, .25);
	border-radius: 8px;
	padding: 22px 34px 42px;
	position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    left: 50%;
	overflow-y: auto;
		&::-webkit-scrollbar {
			width: 12px;
			height: 12px;
		}

		&::-webkit-scrollbar-track {
			background: #eceeef;
		}

		&::-webkit-scrollbar-thumb {
			background-color: #42526e;
			border-radius: 20px;
			border: 1px solid #eceeef;
		}
		scrollbar-width: thin;
		scrollbar-color: #42526e #eceeef;

    @include mq(1025px) {
		// position: absolute;
		// transform: translate(-50%, -50%);
		// left: 50%;
		// top: 50%;
		// height: 70vh;
		padding: 60px 30px;
    }

    @include mq(640px) {
		height: 70vh;
        padding: 80px 15px;
    }
}

.popup__title {
    margin-bottom: 17px;
    font-size: 20px;

    @include mq($lg) {
        font-size: 18px;
        margin-bottom: 20px;
    }

    @include mq($md) {
        font-size: 16px;
    }

    @include mq($sm) {
        font-size: 15px;
    }

	&--name {
		margin-bottom: 0;
	}

	&--date {
		margin-bottom: 6px;
	}
}

.popup__btn-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
	padding: 0 50px;
    max-width: 100%;
    width: 100%;

    @include mq($lg) {
        padding: 0 30px;
        justify-content: space-around;
    }

    @include mq($sm) {
        padding: 0 20px;
    }
}

.popup__btn {
    @include mq(400px) {
        padding: 5px;
        max-width: 100px;
    }
}

.popup__btn {
	align-self: flex-end;
}

.popup__table {
	margin-bottom: 25px;

	@include mq($lg) {
		margin-bottom: 15px;
	}
}

.section-subtitle {
	display: block;
	font-family: $font-main;
	font-weight: 400;
	font-size: 16px;
	color: $shuttle-gray;
}
</style>
